export const NUMBER_OF_MEDIA_TO_PREVIEW = 4;
